import { Injectable } from '@angular/core';
import { SelectOptionLoaderI } from '../../../../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { select, Store } from '@ngrx/store';
import { OrderBuilderState } from '../../../../../reducers';
import { UntypedFormGroup } from '@angular/forms';
import { AddedValueFieldConfig } from '../../../models/form-added-value-field-config';
import { Observable } from 'rxjs';
import { SelectOptionI } from '../../../../../../shared/modules/configurable-form/components/form-multiselect/models/select-option-i';
import { SpecFieldNames } from '../../../../specification/constants/specification-field-names.enum';
import { map } from 'rxjs/operators';
import { ValueAddedOP } from '@cemex-core/cmx-api';
import { getTemperatureVaps } from '../../../selectors/added-value.selectors';
import { ValueAddedCategoryCode } from '../../../../../../shared/services/experiences.service';
import { _safe } from '../../../../../../shared/utils/safe-get.method';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SummerSetLoaderService implements SelectOptionLoaderI {
  constructor(
    private store: Store<OrderBuilderState>,
    private translate: TranslateService,
  ) {}

  /**
   * Provides an observable of paymentTerms
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(formGroup: UntypedFormGroup, config: AddedValueFieldConfig): Observable<SelectOptionI[]> {
    const formId = formGroup.get(SpecFieldNames.ID).value;
    return this.store.pipe(
      select(getTemperatureVaps),
      map((temperaturesVaps) => {
        const temperaturesAvailable = _safe(() => temperaturesVaps[formId], undefined);
        if (!!temperaturesAvailable && temperaturesAvailable.length > 0) {
          return this.getAddedValuesToShow(temperaturesAvailable);
        } else {
          return [];
        }
      }),
    );
  }

  private getAddedValuesToShow(addedValues: ValueAddedOP[]): SelectOptionI[] {
    // const addedValuesToShow = addedValues.filter(value => value['isTemperatureControl'] === false);
    if (addedValues.length > 0) {
      // options is all vaps available
      const filterRe = addedValues.filter(
        (x) =>
          x.valueAddedCategoryCode !== ValueAddedCategoryCode.ICE &&
          x.valueAddedCategoryCode !== ValueAddedCategoryCode.NITROGEN,
      );
      return filterRe.map((addedValue) => {
        return {
          id: addedValue.valueAddedCode,
          name: `${addedValue.valueAddedCode.replace(/^0+/, '')} / ${addedValue.valueAddedDesc}`,
          ...(addedValue.isSpecialized
            ? {
                secondaryText: this.translate.instant(
                  'views.multiple_orders.template.temperature_management.summerset.review_required',
                ),
              }
            : {}),
        };
      });
    } else {
      return [];
    }
  }
}
